const formatNumber = (number, decimals) =>
  Number(Number(number ?? 0)?.toFixed(decimals) ?? 0);

// Debounce function to avoid unnecesary calls
function debounce(callback, wait) {
  let timerId;
  return (...args) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      callback(...args);
    }, wait);
  };
}

const dataURItoBlob = (dataURI) => {
  const [meta, base64] = dataURI.split(",");
  const mimeType = meta.match(/:(.*?);/)?.[1] || "application/octet-stream";
  const byteString = atob(base64);
  const arrayBuffer = new Uint8Array(byteString.length);

  for (let i = 0; i < byteString.length; i++) {
    arrayBuffer[i] = byteString.charCodeAt(i);
  }

  return new Blob([arrayBuffer], { type: mimeType });
};

const readFileAsDataURL = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

const groupBy = (arr, keysSupplier) => {
  return arr.reduce((obj, elt) => {
    let key = keysSupplier(elt);
    if (obj[key] === undefined) obj[key] = [];
    obj[key].push(elt);
    return obj;
  }, {});
};

const sortAscByDate = (arr, dateKey = "createdAt") =>
  arr.slice().sort((a, b) => new Date(a[dateKey]) - new Date(b[dateKey]));

const convertToSlug = (text) =>
  text
    .toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "");

export {
  formatNumber,
  debounce,
  dataURItoBlob,
  readFileAsDataURL,
  groupBy,
  sortAscByDate,
  convertToSlug,
};
